<template>
  <div>
    <div class="tips-bar">
      <i class="iconfont icon-warning-fill" />
      <div class="right-bar">
        <div>
          流程运行至该节点后，进行中断，然后系统开始轮询调用配置选择的云函数，频率为一分钟一次，用户需要在云函数中实现业务自定义的判断逻辑:
        </div>
        <div>返回值为1时，表示流程可以继续向下执行；</div>
        <div>
          返回值为0时，表示流程需要在当前节点位置阻断，仅当等待云函数返回1时，才可继续向下执行；
        </div>
      </div>
    </div>
    <div class="node-title">节点ID</div>
    <el-input disabled :value="value.id" />
    <div class="node-title">
      节点名称
      <span class="require">*</span>
    </div>
    <el-input
      :value="value.fullname"
      maxlength="20"
      show-word-limit
      @input="(e) => valueUpdate('fullname', e)"
    />
    <div class="node-title">变量配置</div>
    <slot name="inputs"></slot>
    <div class="node-title">
      自定义云函数
      <span class="require">*</span>
    </div>
    <slot name="selectFunction"></slot>
    <div class="node-title">备注描述</div>
    <el-input
      type="textarea"
      :rows="2"
      :value="value.description"
      @input="(e) => valueUpdate('description', e)"
      maxlength="50"
      autocomplete="off"
      placeholder="请输入"
    ></el-input>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {},

  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/inputNumber.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/radio.scss';
@import '@/styles/element/button.scss';

.node-title {
  margin-top: 8px;
  margin-bottom: 8px;
  color: #1c2028;
  font-weight: 700;
  .require {
    color: #e34d59;
  }
}
.time-inputbar {
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: #f6f7fb;
}
.intro-title {
  height: 40px;
  line-height: 40px;
  background: #f6f7fb;
  font-weight: 500;
  font-size: 14px;
  color: #667082;
  margin: 10px -10px 0;
  padding-left: 10px;
}
.tips-bar {
  display: flex;
  background: #d9e1ff;
  padding: 8px 16px;
  margin-bottom: 16px;
  margin-left: -16px;
  margin-right: -16px;
  .iconfont {
    font-size: 14px;
    margin-right: 8px;
    color: #0077ff;
    margin-top: 4px;
  }
  .right-bar {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #384050;
  }
}
</style>
